import clsx from 'clsx';
import styles from './PriceToggle.module.scss';
import { TOKEN_ADA_TICKER, TOKEN_USD_TICKER } from '@/src/lib/MayzSmartDB';
import { useTokensStore } from '@/src/store/global/useGlobalStore';

interface PriceToggleProps {
    compact?: boolean;
}

export default function PriceToggle(props: PriceToggleProps) {
    const { compact = false } = props;
    const { displayCurrency, toggleDisplayCurrency, isFetchingAdaPrice, adaUsdPrice, adaPriceError } = useTokensStore();

    const hasValidPrice = typeof adaUsdPrice === 'number' && adaUsdPrice > 0;
    const hasError = Boolean(adaPriceError);
    const canToggle = hasValidPrice && !isFetchingAdaPrice;

    const handleToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        if (canToggle) {
            toggleDisplayCurrency();
        }
    };

    return (
        <button
            type="button"
            className={clsx(styles.toggle, compact && styles.compact, displayCurrency === 'usd' ? styles.usdSelected : styles.adaSelected)}
            onClick={handleToggle}
            disabled={!canToggle}
        >
            <span className={clsx(styles.label, displayCurrency === 'ada' && styles.active)}>{TOKEN_ADA_TICKER}</span>
            <span className={styles.separator}>/</span>
            <span className={clsx(styles.label, displayCurrency === 'usd' && styles.active)}>{TOKEN_USD_TICKER}</span>
            {isFetchingAdaPrice ? (
                <span className={styles.loadingDot} aria-hidden="true" />
            ) : hasError ? (
                <span className={clsx(styles.loadingDot, styles.errorDot)} aria-hidden="true" />
            ) : null}
        </button>
    );
}
